import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type VendorDetailsFragment = { __typename?: 'VendorDocument', description: string, erpId: string, id: string, lastModified?: Types.TDateISO | null, name: string, status: Types.VendorStatus, tenantId: string, vendorId: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null };

export type VendorStateFragment = { __typename?: 'VendorStateData', description: string, erpId: string, id: string, name: string, status: Types.VendorStatus, tenantId: string, billingAddress?: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null };

export type GetVendorsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.VendorDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.VendorDocumentSortInput> | Types.VendorDocumentSortInput>;
}>;


export type GetVendorsQuery = { __typename?: 'Query', vendors?: { __typename?: 'VendorsConnection', totalCount: number, nodes?: Array<{ __typename?: 'VendorDocument', description: string, erpId: string, id: string, lastModified?: Types.TDateISO | null, name: string, status: Types.VendorStatus, tenantId: string, vendorId: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const VendorDetailsFragmentDoc = new TypedDocumentString(`
    fragment VendorDetails on VendorDocument {
  billingAddress {
    ...AddressData
  }
  description
  erpId
  id
  lastModified
  name
  status
  tenantId
  vendorId
}
    fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"VendorDetails"});
export const VendorStateFragmentDoc = new TypedDocumentString(`
    fragment VendorState on VendorStateData {
  billingAddress {
    ...Address
  }
  description
  erpId
  id
  name
  status
  tenantId
}
    fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"VendorState"});
export const GetVendorsDocument = new TypedDocumentString(`
    query GetVendors($first: Int, $after: String, $last: Int, $before: String, $where: VendorDocumentFilterInput, $order: [VendorDocumentSortInput!]) {
  vendors(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...VendorDetails
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment VendorDetails on VendorDocument {
  billingAddress {
    ...AddressData
  }
  description
  erpId
  id
  lastModified
  name
  status
  tenantId
  vendorId
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetVendors: build.query<GetVendorsQuery, GetVendorsQueryVariables | void>({
      query: (variables) => ({ document: GetVendorsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetVendorsQuery, useLazyGetVendorsQuery } = injectedRtkApi;
